import { ProductType } from '@mfe/shared/schema-types';

export function matchAddonWithFreeDiscount(
  productType: ProductType,
  rootProductType: ProductType
) {
  /*
  According to the catalog EasyCare products will be free for the first 3 months
  Addon discounts match addon prices in value, but discount amounts are negative

  TODO: Update logic here if OFM provides the discounts on each product type in the group
  */
  return rootProductType?.discounts?.itemized_discounts?.find((discount) => {
    return discount?.amount?.value && productType?.prices?.[0]?.amount?.value
      ? discount?.amount?.value + productType?.prices?.[0]?.amount?.value === 0
      : undefined;
  });
}
